import { render, staticRenderFns } from "./ModalNotificacoes.vue?vue&type=template&id=555f776d&scoped=true"
import script from "./ModalNotificacoes.vue?vue&type=script&lang=js"
export * from "./ModalNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificacoes.vue?vue&type=style&index=0&id=555f776d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f776d",
  null
  
)

export default component.exports